import { SocialMediaPost } from '@/components/landing/SocialPostCarousel';

const socialPostsTop: SocialMediaPost[] = [
  {
    id: '1',
    content:
      'BREAKING BIG: @Hivemapper, a decentralized mapping network built on @solana, has achieved a major milestone by mapping about one-third (33%) of the global road network.',
    author: 'SolanaFloor',
    authorTag: '@SolanaFloor',
    url: 'https://x.com/SolanaFloor',
  },
  {
    id: '2',
    content:
      'Hello everyone, after several weeks of mapping, I just released a video on the new Bee @Hivemapper! The experience is really great because this new dashcam is not only an upgrade compared to old models, HDC...',
    author: 'Osvaldo',
    authorTag: '@ilCapoFox',
    url: 'https://x.com/CapFox',
  },
  {
    id: '3',
    content:
      'Never thought I would see this day @Hivemapper now I gotta plan trips to Sacramento and Salt Lake City to deploy in my company trucks!',
    author: 'treowx.eth/cro',
    authorTag: '@treowx',
    url: 'https://x.com/treowx',
  },
  {
    id: '4',
    content:
      "Big W for @Hivemapper and a massive signal for DePIN. When Kings like this just auto decentralized map data, you know the model's working. Fresh, real-time, crowd-powered mapping is the future.",
    author: 'depin.house',
    authorTag: '@depinhouse',
    url: 'https://x.com/depinhouse',
  },
  {
    id: '5',
    content:
      'One of the most underrated areas in crypto: DePIN, such as @Hivemapper. It changes how real-world infra (eg. mapping, wireless networks) is deployed and managed by distributing the work to individuals...',
    author: 'Eda',
    authorTag: '@eda4web3',
    url: 'https://x.com/eda4web3',
  },
  {
    id: '6',
    content:
      'Lyft is using Hivemapper, built on Solana. Somewhere in Mountain View, a Google PM is scrambling.',
    author: 'Anh Tran',
    authorTag: '@SaigonButcher',
    url: 'https://x.com/SaigonButcher',
  },
  {
    id: '7',
    content:
      'I love Hivemapper. The bee is incredible! Great job on this device.',
    author: 'MG.carpet',
    authorTag: '@mg_carpet',
    url: 'https://x.com/mg_carpet',
  },
  {
    id: '8',
    content: 'I love what @Hivemapper is building',
    author: 'Funmi',
    authorTag: '@im_funmi3',
    url: 'https://x.com/im_funmi3',
  },
  {
    id: '9',
    content:
      'I love how projects like Helium and Hivemapper are leading the way in creating decentralized networks for services such as wireless connectivity and mapping, indicating a shift towards community-owned...',
    author: 'THE ANALYST',
    authorTag: '@Web3Analyst',
    url: 'https://x.com/Web3Analyst',
  },
  {
    id: '10',
    content:
      'Love my new @Hivemapper Bee, images are way more crisp and the cam works a lot better. Thanks @Rasiedlam for shipping such a good quality product.',
    author: 'Lisandro',
    authorTag: '@LisandroIT',
    url: 'https://x.com/LisandroIT',
  },
];

const socialPostsBottom: SocialMediaPost[] = [
  {
    id: '1',
    content:
      "Don't quit your job to map & earn. Just do your regular driving & enjoy passive income with @Hivemapper week after week. I love earning sweet $HONEY & contribute to #Decentralization. We can all do our...",
    author: 'Legend',
    authorTag: '@Legend4831',
    url: 'https://x.com/Legend4831',
  },
  {
    id: '2',
    content:
      "It's so beautiful I am gonna cry! Thank you @aseidman, @Hivemapper, @TrevBeMacs team. I know how hard you guys have worked to make this a reality. Absolutely amazing work love the solidness and attention to detail.",
    author: 'AshHardy',
    authorTag: '@HardyAzxee',
    url: 'https://x.com/HardyAzxee',
  },
  {
    id: '3',
    content:
      'Hivemapper feels like a sleeping giant... A global, crowdsourced map in a digital age sitting at a $100M market cap... with a burn mechanism correlated to revenue. How are more people not...',
    author: 'THRiLE',
    authorTag: '@AvvTheATK',
    url: 'https://x.com/AvvTheATK',
  },
  {
    id: '4',
    content: 'love what hivemapper is doing',
    author: 'Oxirann (def/maxi)',
    authorTag: '@imrafaststart',
    url: 'https://x.com/imrafaststart',
  },
  {
    id: '5',
    content:
      "Gotta love what @Hivemapper is building and I can't wait to receive my Bee units! An amazing partner for us at @thehouseofweb3.",
    author: 'george',
    authorTag: '@georgeofweb3_sf',
    url: 'https://x.com/georgeofweb3_sf',
  },
  {
    id: '6',
    content:
      "I LOVE @Hivemapper and it's my go-to example to help normies to understand the IRL power of blockchain. Changing lives bruv.",
    author: 'Dr. Revel / Ace',
    authorTag: '@DrRebekkaRevel',
    url: 'https://x.com/DrRebekkaRevel',
  },
  {
    id: '7',
    content:
      "@lyft announcing their use of @Hivemapper's community built maps is a great reminder of why I love DePIN. This isn't just a win for @Hivemapper. It's a win for the people around the world who built this map.",
    author: 'AmiraV',
    authorTag: '@amiravillain',
    url: 'https://x.com/amiravillain',
  },
  {
    id: '8',
    content:
      'Hivemapper goes beyond roadways... I really love this addition and I think this is the perfect direction/answer to “what else can be sourced with real-time street-level imagery?” Just imagine what you can create with all that...',
    author: 'Jesse',
    authorTag: '@JB3RG_',
    url: 'https://x.com/JB3RG_',
  },
  {
    id: '9',
    content:
      'I really love what @Hivemapper are bringing in the space–feels so good to have a map on-chain that I will always own when on the road and still get HONEY.',
    author: 'Analyst',
    authorTag: '@untim3d_analyst',
    url: 'https://x.com/untim3d_analyst',
  },
  {
    id: '10',
    content:
      'App spotlight: @Hivemapper. Enter @Hivemapper – a decentralized mapping network on @solana, built and collectively owned by its contributors...',
    author: 'Phantom',
    authorTag: '@phantom',
    url: 'https://x.com/phantom',
  },
  {
    id: '11',
    content:
      'hivemapper is the most innovative and underrated company in all of crypto',
    author: 'mert | helius.dev',
    authorTag: '@0xMert_',
    url: 'https://x.com/0xMert_',
  },
];

export { socialPostsTop, socialPostsBottom };
